import { h, render, Component } from "preact";

import { defaultSortDirection, updateAddressBar } from "../lib/utilities";

import PlayerSearchBar from "./player-search-bar-component";
import PlayerDataRow from "./player-data-row-component";
import SortableTableHeader from "./sortable-table-header-component";
import FilterBar from "./player-filter-list-component";

const POSITIONS = new Set(["PG", "SG", "SF", "PF", "C"]);

export default class PlayerListTable extends Component {
  constructor(props) {
    super(props);

    // TODO: combine rookies, minimum, positions into one filters obj/array
    this.state = {
      sort: props.sort,
      direction: props.direction,
      rookies: props.rookies,
      minimum: props.minimum,
      positions: props.positions,
      // N.B. This is `q` to preserve backwards copatibility with the old URLs
      q: props.filterText,
      loading: !Array.isArray(props.playerList.players)
    };

    this.handleSortLinkClick = this.handleSortLinkClick.bind(this);
    this.handleFilterDelete = this.handleFilterDelete.bind(this);
    this.handleFilterAdd = this.handleFilterAdd.bind(this);

    this.handleFilterTextInput = this.handleFilterTextInput.bind(this);
    this.handleClearFilterText = this.handleClearFilterText.bind(this);
    this.clearFilters = this.clearFilters.bind(this);

    this.handleSeasonChange = this.handleSeasonChange.bind(this);

    if (this.state.loading) {
      this.props.playerList.fetch().then(() => {
        this.setState({
          loading: void 0
        });
      });
    }
  }

  handleFilterTextInput(filterText) {
    if (filterText === "") {
      return this.handleClearFilterText();
    }

    this.setState({
      q: filterText
    });
  }

  handleClearFilterText() {
    this.setState({
      q: void 0
    });
  }

  handleSortLinkClick(e) {
    e.preventDefault();

    const data = e.currentTarget.dataset;

    this.setState({
      sort: data.sort,
      direction: data.direction
    });
  }

  handleFilterDelete(filter) {
    if (isPositionFilter(filter)) {
      return this.deletePositionFilter(filter);
    }

    this.setState({
      [filter]: void 0
    });
  }

  handleFilterAdd(filter) {
    if (isPositionFilter(filter)) {
      return this.addPositionFilter(filter);
    }

    this.setState({
      [filter]: true
    });
  }

  addPositionFilter(position) {
    const currentPositions = this.currentPositionSet();

    // Don't trigger state changes unless necessary
    if (currentPositions.has(position)) {
      return;
    }

    currentPositions.add(position);
    this.setState({
      positions: Array.from(currentPositions)
    });
  }

  deletePositionFilter(position) {
    const currentPositions = this.currentPositionSet();

    // Don't trigger state changes unless necessary
    if (!currentPositions.has(position)) {
      return;
    }

    currentPositions.delete(position);

    this.setState({
      positions:
        currentPositions.size === 0 ? void 0 : Array.from(currentPositions)
    });
  }

  handleSeasonChange(year) {
    this.setState({ loading: true });

    this.props.playerList.setSeason(year);
    this.props.playerList.fetch().then(() => {
      this.setState({
        season: year,
        loading: void 0
      });
    });
  }

  clearFilters() {
    this.setState({
      rookies: void 0,
      minimum: void 0,
      positions: void 0
    });
  }

  currentPositionSet() {
    return new Set(this.state.positions);
  }

  render(props, state) {
    if (this.state.loading) {
      return <div class="loader">Loading...</div>;
    }

    const sortBy = this.state.sort || "name";
    const sortDirection = this.state.direction || defaultSortDirection(sortBy);

    let players = props.playerList.sortBy(sortBy, sortDirection);

    // TODO: Genericize filters
    if (state.rookies) {
      players = players.filter(p => p.is_rookie);
    }

    if (state.minimum) {
      players = players.filter(
        p => p.minutes > props.playerList.minMinutesThreshold()
      );
    }

    if (state.positions) {
      const positionSet = this.currentPositionSet();
      players = players.filter(
        p =>
          positionSet.has(p.position) || positionSet.has(p.secondary_position)
      );
    }

    if (state.q) {
      const regex = new RegExp(state.q, "i");
      players = players.filter(p => regex.test(p.name));
    }

    const rows = players.map(player => <PlayerDataRow player={player} />);
    // Note: this is not likely to be exactly accurate, but does not need to be.

    const lastUpdated = players[0] ? players[0].updated_at : "n/a";

    updateAddressBar(state);

    return (
      <div class="player-list-table">
        <PlayerSearchBar
          filterText={state.q}
          onFilterTextInput={this.handleFilterTextInput}
          onClearFilterText={this.handleClearFilterText}
        />

        <FilterBar
          rookies={state.rookies}
          isPlayoffs={props.isPlayoffs}
          season={state.season}
          minimum={state.minimum}
          minMinutesThreshold={props.playerList.minMinutesThreshold()}
          positions={state.positions}
          onRemoveFilter={this.handleFilterDelete}
          onAddFilter={this.handleFilterAdd}
          onClear={this.clearFilters}
          onSeasonChange={this.handleSeasonChange}
        />

        <div class="stats-table-wrapper">
          <table class="stats-table player-stats-table">
            <SortableTableHeader
              sort={sortBy}
              direction={sortDirection}
              onSortLinkClick={this.handleSortLinkClick}
            />
            <tbody>{rows}</tbody>
          </table>
        </div>

        <p class="small">Last Updated: {lastUpdated}</p>
      </div>
    );
  }
}

function isPositionFilter(filterName) {
  return POSITIONS.has(filterName);
}



// WEBPACK FOOTER //
// ./app/javascript/components/player-list-table-component.js